import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgPatientBed = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M13.875 4.5C13.875 4.74623 13.9235 4.99005 14.0177 5.21753C14.112 5.44502 14.2501 5.65172 14.4242 5.82582C14.5983 5.99993 14.805 6.13805 15.0325 6.23227C15.26 6.3265 15.5038 6.375 15.75 6.375C15.9962 6.375 16.24 6.3265 16.4675 6.23227C16.695 6.13805 16.9017 5.99993 17.0758 5.82582C17.2499 5.65172 17.388 5.44502 17.4823 5.21753C17.5765 4.99005 17.625 4.74623 17.625 4.5C17.625 4.25377 17.5765 4.00995 17.4823 3.78247C17.388 3.55498 17.2499 3.34828 17.0758 3.17417C16.9017 3.00006 16.695 2.86195 16.4675 2.76773C16.24 2.6735 15.9962 2.625 15.75 2.625C15.5038 2.625 15.26 2.6735 15.0325 2.76773C14.805 2.86195 14.5983 3.00006 14.4242 3.17417C14.2501 3.34828 14.112 3.55498 14.0177 3.78247C13.9235 4.00995 13.875 4.25377 13.875 4.5V4.5Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7 15.75C7 15.9962 7.0485 16.24 7.14273 16.4675C7.23695 16.695 7.37507 16.9017 7.54917 17.0758C7.72328 17.2499 7.92998 17.388 8.15747 17.4823C8.38495 17.5765 8.62877 17.625 8.875 17.625C9.12123 17.625 9.36505 17.5765 9.59253 17.4823C9.82002 17.388 10.0267 17.2499 10.2008 17.0758C10.3749 16.9017 10.513 16.695 10.6073 16.4675C10.7015 16.24 10.75 15.9962 10.75 15.75C10.75 15.5038 10.7015 15.26 10.6073 15.0325C10.513 14.805 10.3749 14.5983 10.2008 14.4242C10.0267 14.2501 9.82002 14.112 9.59253 14.0177C9.36505 13.9235 9.12123 13.875 8.875 13.875C8.62877 13.875 8.38495 13.9235 8.15747 14.0177C7.92998 14.112 7.72328 14.2501 7.54917 14.4242C7.37507 14.5983 7.23695 14.805 7.14273 15.0325C7.0485 15.26 7 15.5038 7 15.75V15.75Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.625 13.875H19.7083C20.1504 13.875 20.5743 14.0506 20.8868 14.3632C21.1994 14.6757 21.375 15.0996 21.375 15.5417V17.625H12.625V13.875Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.875 17.625H21.375V20.125H3.875V17.625Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.875 21.375V13.875"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M21.375 21.375V20.125"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.625 11.375C12.625 10.712 12.8884 10.0761 13.3572 9.60723C13.8261 9.13839 14.462 8.875 15.125 8.875H16.375C17.038 8.875 17.6739 9.13839 18.1428 9.60723C18.6116 10.0761 18.875 10.712 18.875 11.375"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.5 5.125H7.625V3.25C7.625 3.08424 7.55915 2.92527 7.44194 2.80806C7.32473 2.69085 7.16576 2.625 7 2.625H5.75C5.58424 2.625 5.42527 2.69085 5.30806 2.80806C5.19085 2.92527 5.125 3.08424 5.125 3.25V5.125H3.25C3.08424 5.125 2.92527 5.19085 2.80806 5.30806C2.69085 5.42527 2.625 5.58424 2.625 5.75V7C2.625 7.16576 2.69085 7.32473 2.80806 7.44194C2.92527 7.55915 3.08424 7.625 3.25 7.625H5.125V9.5C5.125 9.66576 5.19085 9.82473 5.30806 9.94194C5.42527 10.0592 5.58424 10.125 5.75 10.125H7C7.16576 10.125 7.32473 10.0592 7.44194 9.94194C7.55915 9.82473 7.625 9.66576 7.625 9.5V7.625H9.5C9.66576 7.625 9.82473 7.55915 9.94194 7.44194C10.0592 7.32473 10.125 7.16576 10.125 7V5.75C10.125 5.58424 10.0592 5.42527 9.94194 5.30806C9.82473 5.19085 9.66576 5.125 9.5 5.125Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgPatientBed.displayName = 'SvgPatientBed';
export default SvgPatientBed;
